import i18n from '../plugins/i18n';

const COMMISSIONING_STATUS_CONFIG = [
  {
    value: 'ORDER_CREATED',
    labelKey: 'commissioning.statuses.ORDER_CREATED',
    color: '#d79bb8',
  },
  {
    value: 'CRITICAL_ORDER_CREATED',
    labelKey: 'commissioning.statuses.CRITICAL_ORDER_CREATED',
    color: '#d79bb8',
  },
  {
    value: 'ORDER_TECHNICAL_FEASIBILITY',
    labelKey: 'commissioning.statuses.ORDER_TECHNICAL_FEASIBILITY',
    color: '#CF8AA9',
  },
  {
    value: 'ORDER_ACCEPTED',
    labelKey: 'commissioning.statuses.ORDER_ACCEPTED',
    color: '#9B0040',
  },
  {
    value: 'TRANSMITTED',
    labelKey: 'commissioning.statuses.TRANSMITTED',
    color: '#9B0040',
  },
  {
    value: 'ORDER_CANCELLED',
    labelKey: 'commissioning.statuses.ORDER_CANCELLED',
    color: '#767676',
  },
  {
    value: 'ORDER_DECLINED',
    labelKey: 'commissioning.statuses.ORDER_REJECTED',
    color: '#525252',
  },
  {
    value: 'WMSB_ORDER_CREATED',
    labelKey: 'commissioning.statuses.WMSB_ORDER_CREATED',
    color: '#d79bb8',
    rowGroup: 'wmsb',
  },
  {
    value: 'WMSB_IN_REVIEW',
    labelKey: 'commissioning.statuses.WMSB_IN_REVIEW',
    color: '#CF8AA9',
    rowGroup: 'wmsb',
  },
  {
    value: 'WMSB_TRANSMITTED',
    labelKey: 'commissioning.statuses.WMSB_TRANSMITTED',
    color: '#9B0040',
    rowGroup: 'wmsb',
  },
];

const COMMISSIONING_PIPELINE_GROUPS = [
  {
    value: 'new',
    label: i18n.t('commissioning.pipeline_statuses.new'),
    color: '#d79bb8',
    summaryKeys: [
      'count_order_created',
      'count_critical_order_created',
      'count_wmsb_order_created',
    ],
  },
  {
    value: 'in_review',
    label: i18n.t('commissioning.pipeline_statuses.in_review'),
    color: '#CF8AA9',
    summaryKeys: [
      'count_in_review',
      'count_order_technical_feasibility',
      'count_wmsb_in_review',
    ],
  },
  {
    value: 'transmitted',
    label: i18n.t('commissioning.pipeline_statuses.transmitted'),
    color: '#9B0040',
    summaryKeys: [
      'count_order_accepted',
      'count_transmitted',
      'count_order_confirmed',
      'count_wmsb_transmitted',
    ],
  },
  {
    value: 'cancelled',
    label: i18n.t('commissioning.pipeline_statuses.cancelled'),
    color: '#767676',
    summaryKeys: ['count_order_cancelled'],
  },
  {
    value: 'rejected',
    label: i18n.t('commissioning.pipeline_statuses.rejected'),
    color: '#525252',
    summaryKeys: ['count_order_rejected', 'count_order_declined'],
  },
];

const DEFAULT_STATUS_COLOR = '#999999';

export function getCommissioningStatusValuesList(isAllItemNeeded = true) {
  const statuses = COMMISSIONING_STATUS_CONFIG.map((status) => ({
    value: status.value,
    color: status.color,
    label: i18n.t(status.labelKey),
    rowGroup: status.rowGroup,
  }));

  if (isAllItemNeeded) {
    statuses.unshift({ label: 'alle', value: 'all', color: '#999999' });
  }

  return statuses;
}

export function getCommissioningPipelineStatusesConfig() {
  return COMMISSIONING_PIPELINE_GROUPS.map((status) => ({ ...status }));
}

function getCommissioningStatusConfig(statusValue) {
  const normalizedStatusValue =
    typeof statusValue === 'string' ? statusValue.toUpperCase() : statusValue;
  const statusConfig = COMMISSIONING_STATUS_CONFIG.find(
    (status) => status.value === normalizedStatusValue
  );

  if (!statusConfig) {
    return null;
  }

  return {
    label: i18n.t(statusConfig.labelKey),
    value: statusValue,
    color: statusConfig.color,
  };
}

export function getCommissioningStatusDisplay(statusValue) {
  return (
    getCommissioningStatusConfig(statusValue) || {
      label: statusValue,
      value: statusValue,
      color: DEFAULT_STATUS_COLOR,
    }
  );
}

export function getCommissioningPipelineStatusAmount(summary = {}, status) {
  return status.summaryKeys.reduce(
    (count, key) => count + normalizeCount(summary[key]),
    0
  );
}

function normalizeCount(value) {
  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
}
